module.exports = __webpack_public_path__ + "img/USER_SUCCESS.da013d5e.svg";